import {Mesh, PlaneBufferGeometry} from 'three'
import {getMaterial} from './Materials'
import {materialTypes} from './MaterialTypes'

export function addBackground(scene) {
    const geometry = new PlaneBufferGeometry(2000, 2000)
    const material = getMaterial(materialTypes.background)

    const mesh = new Mesh(geometry, material)
    mesh.name = 'background'
    mesh.position.set(0, 0, -1)

    scene.add(mesh)
}